export const IMPACT_THRESHOLDS = [0.007, 0.014, 0.025] as const;

/**
 * Converts impactDelta to filled zap count (1-4)
 */
export function getFilledZapCount(impactDelta: number): number {
  if (impactDelta < IMPACT_THRESHOLDS[0]) return 1;
  if (impactDelta < IMPACT_THRESHOLDS[1]) return 2;
  if (impactDelta < IMPACT_THRESHOLDS[2]) return 3;
  return 4;
}

/**
 * Mapping from metric keys to human-readable display labels
 */
export const METRIC_LABELS: Record<string, string> = {
  avg_carousel_score: 'Average Carousel Score',
  visual_diversity: 'Visual Diversity',
  n_carousel_images: 'Asset Count',
  order_score: 'Asset Order',
};

/**
 * Get a human-readable label for a metric key
 * Falls back to a formatted version of the key if not found in the mapping
 */
export function getMetricLabel(key: string): string {
  if (METRIC_LABELS[key]) {
    return METRIC_LABELS[key];
  }

  // Fallback: convert snake_case to Title Case
  return key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
